import { memo } from 'react'

import { Chip, Stack } from '@collaborate-health/uikit'
import { useSelector } from '@tabeeb/store'
import AnswerStatusFilter from '@tabeeb/modules/forms/components/AnswerStatusFilter'
import { getDisplayAnswersMode, getFormAnswerStatusStatistics } from '@tabeeb/modules/forms/selectors'
import { FormAnswerStatus } from '@tabeeb/contracts/main-api/swagger-main-api'

import { DisplayAnswersMode } from '../../enums'

const AnswerStatusStatistics: React.FC = () => {
  const displayAnswersMode = useSelector(getDisplayAnswersMode)
  const answerStatusStatistics = useSelector(getFormAnswerStatusStatistics)

  if (displayAnswersMode !== DisplayAnswersMode.AllLatest) {
    return null
  }

  const getStatusCount = (answerStatus: FormAnswerStatus) => {
    return answerStatusStatistics.find((st) => st.FormAnswerStatus === answerStatus)?.Count || 0
  }

  return (
    <Stack alignItems='center' direction='row' spacing={1}>
      <Stack justifyContent='flex-start' direction='row' flex={1} spacing={0.75}>
        <Chip size='small' label={`Submitted: ${getStatusCount(FormAnswerStatus.Pending)}`} color='info' />
        <Chip size='small' label={`Approved: ${getStatusCount(FormAnswerStatus.Pass)}`} color='success' />
        <Chip size='small' label={`Rejected: ${getStatusCount(FormAnswerStatus.Fail)}`} color='error' />
      </Stack>

      <AnswerStatusFilter />
    </Stack>
  )
}

export default memo(AnswerStatusStatistics)

